import { WATCHLIST_GROUPS, WATCHLIST_GROUPS_ERROR, WATCHLIST_GROUPS_HIDE_ERROR, WATCHLIST_GROUPS_START_LOADER, WATCHLIST_GROUPS_STOP_LOADER, } from "../interface/IWatchListGroups";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const WatchListGroups = (state = initState, action) => {
    switch (action.type) {
        case WATCHLIST_GROUPS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case WATCHLIST_GROUPS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case WATCHLIST_GROUPS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case WATCHLIST_GROUPS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case WATCHLIST_GROUPS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default WatchListGroups;
